<template>
	<app>
		<c-form ref="form">
			<c-form-item type="hidden" name="tz_id"></c-form-item>
			<c-form-item v-model="currentProjectId" type="select" label="所属项目" name="project_id" :options="projectList" required :disabled="!!id"></c-form-item>
			<c-form-item type="input" label="企业单位" name="zbqy_name" required disabled></c-form-item>
			<c-form-item type="input" label="监理单位" name="jldw_name" required disabled></c-form-item>
			<c-form-item type="input" label="业主单位" name="yzdw_name" required disabled></c-form-item>
			<c-form-item type="file" label="审批材料" name="file_path" required file-type="pdf" file-size="3072"></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="remark"></c-form-item>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确认提交</c-button>
		</div>
	</app>
</template>

<script>
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				projectList: [],
				currentProjectId: ''
			}
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.form.set({
								yzdw_name: data.project_info.yzdw_name,
								jldw_name: data.project_info.jldw_name,
								zbqy_name: data.project_info.zbqy_name
							});
						}
					});
				}
			}
		},
		
		mounted() {
			this.request({
				url: '/project/select_list',
				data: {
					type: 5
				},
				success: data => {
					this.projectList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			});
			
			if (this.id) {
				this.request({
					url: '/project/aqtz/detail',
					data: {
						tz_id: this.id
					},
					success: data => {
						this.$refs.form.set({
							tz_id: data.tzInfo.id
						});
						this.$refs.form.set(data.tzInfo);
					}
				});
			}
		},
		
		methods: {
			submitHandle() {
				this.$refs.form.submit({
					url: this.id ? '/project/aqtz/updateBase' : '/project/aqtz/add',
					rule: {
						project_id: '请选择所属项目',
						file_path: '请上传审批材料'
					},
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>